import { Injectable } from "@angular/core";
import { distinctUntilKeyChanged } from "rxjs/operators";
import { UserService } from "../../../../common/services/api/resources/user/user.service";

const debug = false;

@Injectable({ providedIn: "root" })
export class SignUpUserService extends UserService {
  constructor() {
    super();

    this.session.state.pipe(distinctUntilKeyChanged("sessionId")).subscribe(state => {
      if (state.loggedIn && !!state.sessionId) this.onLogin();
      else if (!state.loggedIn) this.dispose();
    });
  }

  private onLogin(): void {
    debug && console.log("SignUpUserService.onLogin");
    this.userRead();
  }
}
